/*
 * Created on Tue Jul 09 2019
 *
 * Copyright (c) 2019 Laboratori Guglielmo Marconi
 */

import { BrowserModule }                    from '@angular/platform-browser';
import { NgModule }                         from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS }     from '@angular/common/http';
import { BrowserAnimationsModule }          from '@angular/platform-browser/animations';
import { FlexLayoutModule }                 from '@angular/flex-layout';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader }              from '@ngx-translate/http-loader';
import { CookieService }                    from 'ngx-cookie-service';

import {BreadcrumbModule}                   from 'xng-breadcrumb';

import { LayoutModule }                     from '@angular/cdk/layout';

import { AppRoutingModule }                 from './app-routing.module';
import { AppComponent }                     from './app.component';
import { AppMaterialModule }                from './material.module';
import { HeaderComponent }                  from './navigation/header/header.component';
import { LoginComponent }                   from './login/login.component';
import { NewLoginComponent }                from './login/new-login.component';
// SERVICES
import { AuthInterceptor }                  from './_interceptor/AuthInterceptor';
import { InterfaceService }                 from './_service/interface.service';
import { UtilityService }                   from './_service/utility.service';
import { UserService }                      from './_service/user.service';
import { BaseService }                      from './_service/base.service';
import { BackendService }                   from './_service/backend.service';
import { EventEmitterService }              from './_service/event-emitter.service';
import { ResizeService }                    from './_service/resize-service';
import { SessionStorageService }            from './_service/session-storage.service';
import { AttributeService }                 from './_service/attribute.service';
import { GroupService }                     from './_service/group.service';

//COMPONENTS
import { LayoutComponent }                  from './layout/layout.component';
import { ConfirmDialog }                    from './_components/ConfirmDialog';
import { PageableComponent }                from './_components/PageableComponent';
import { LoggedBaseComponent }              from './_components/LoggedBaseComponent';
import { BaseComponent }                    from './_components/BaseComponent';
import { BreadCrumb }                       from './_components/BreadCrumb';
import { MaterialDualListComponent }        from './_components/MaterialDualListComponent';
import { SelectAndChips }                   from './_components/SelectAndChips';
import { CustomAttributeComponent }         from './_components/CustomAttributeComponent';
import { YesNotDialog }                     from './_components/YesNotDialog';
import { ErrorDialog }                      from './_components/ErrorDialog';

//-------------- ZimbraInstance -----------------
import { ZimbraInstanceService }                 from './_service/zimbrainstance.service';
import { ZimbraInstanceManagerComponent }        from './pages/zimbrainstance/zimbrainstance-manager.component';
import { ZimbraInstanceCreateEditComponent }        from './pages/zimbrainstance/zimbrainstance-create-edit.component';


//LOGINS
import { AuslRomaLoginComponent }           from './_components/logincomponents/AuslRomaLoginComponent';
import { AuslRomaLdapLoginComponent }       from './_components/logincomponents/AuslRomaLdapLoginComponent';

//PAGES
import { DashboardComponent }               from './pages/dashboard/dashboard.component';
import { PageNotFoundComponent }            from './pages/page-not-found/page-not-found.component';
import { ErrorSettingsComponent }           from './pages/error-settings/error-settings.component';
import { PermissionDeniedComponent }        from './pages/permission-denied/permission-denied.component';
import { TestPageComponent }                from './pages/testing_page/test-page.component';
import { ForceLogoutComponent }             from './pages/forcelogout/forcelogout.component';
import { RefereeComponent }                 from './layout/referee.component';

import { AdminDashboardComponent }          from './pages/admin/admin-dashboard.component';
import { AuditManagerComponent }            from './pages/audit/audit-manager.component';
import { UserManagerComponent }             from './pages/users/user-manager.component';
import { UserCreateEditComponent }          from './pages/users/user-create-edit.component';

//VARIA
import { PerfectScrollbarModule }           from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG }         from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface }  from 'ngx-perfect-scrollbar';



const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LoginComponent,
    NewLoginComponent,
    DashboardComponent,
    MaterialDualListComponent,
    SelectAndChips,

    ZimbraInstanceManagerComponent,
    ZimbraInstanceCreateEditComponent,

    BreadCrumb,
    ErrorDialog,
    RefereeComponent,

    TestPageComponent,
    ForceLogoutComponent,

    LayoutComponent,
    PermissionDeniedComponent,
    PageNotFoundComponent,
    ErrorSettingsComponent,

    ConfirmDialog,
    PageableComponent,
    LoggedBaseComponent,
    BaseComponent,
    AuslRomaLoginComponent,
    AuslRomaLdapLoginComponent,
    YesNotDialog,
    AdminDashboardComponent,
    UserCreateEditComponent,
    AuditManagerComponent,
    UserManagerComponent,

    CustomAttributeComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BreadcrumbModule,
    BrowserAnimationsModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FlexLayoutModule,
    LayoutModule,  
    PerfectScrollbarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [ 
                InterfaceService, 
                UtilityService, 
                UserService,
                BaseService,
                BackendService,
                CookieService,
		AttributeService,
                GroupService,
                ResizeService,
                EventEmitterService,
                SessionStorageService,
                { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
             ],
  bootstrap       : [ AppComponent ],
  entryComponents : [ ConfirmDialog ]
})


export class AppModule { }
